import { MouseUtil } from "../../../util/view/MouseUtil";
import { AppData } from "../../AppData";
import { GameErrorEvent } from "../../Constants";
import { MouseBlocker } from "../../control/MouseBlocker";
import { CommonGameEvent } from "../../controller/event/CommonGameEvent";
import { DialogEvent } from "../../manager/DialogManager";
import { AbstractView } from "../AbstractView";
/**
 * DetailedGameHistory.ts
 */
export class DetailedGameHistory extends AbstractView {
    constructor(factory, properties, portraitProperties) {
        super(properties, portraitProperties);
        this.factory = factory;
        this.run();
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.properties = this.getCurrentProperties();
        this.responsive = true;
    }
    create() {
        super.create();
        this.createBlocker();
        this.createIFrame();
        this.updateFrameStyle();
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerCore(CommonGameEvent.DGH_OPEN, this.handleDGHOpen);
    }
    createBlocker() {
        this.blocker = new MouseBlocker(this.properties.mouseBlockerProperties);
        this.blocker.onClick(this.handleBlockerSelected, this);
        MouseUtil.addMouseBlock(this.blocker);
    }
    createIFrame() {
        this.dghDiv = document.createElement("div");
        this.dghFrame = document.createElement("iframe");
        let iframeStyle = this.dghFrame.style;
        iframeStyle.width = "100%";
        iframeStyle.height = "100%";
        iframeStyle.border = "0px";
        this.dghDiv.appendChild(this.dghFrame);
        document.body.appendChild(this.dghDiv);
        this.dghDiv.style.display = "none";
        window.addEventListener("message", this.handleMessage.bind(this));
    }
    updateFrameStyle() {
        let divStyle = this.dghFrame.style;
        divStyle.width = this.properties.divWidth;
        divStyle.height = this.properties.divHeight;
        divStyle.position = this.properties.divPosition;
        divStyle.top = this.properties.divTop;
        divStyle.left = this.properties.divLeft;
        divStyle.borderRadius = this.properties.divBorderRadius;
    }
    handleMessage(message) {
        if (message.data["_pixiInspector"])
            return;
        if (message.data["dgh"]) {
            if (message.data["dgh"] == "close") {
                this.hide();
            }
            else if (message.data["dgh"] == "sessionExpired") {
                console.log("Session Expired in DGH");
                this.hide();
                this.dispatchCore(GameErrorEvent.SESSION_TIME_OUT);
            }
        }
    }
    hide() {
        this.dghDiv.style.display = "none";
        this.removeBlocker();
    }
    show() {
        this.addBlocker();
        this.dghDiv.style.display = "block";
    }
    addBlocker() {
        this.dispatchCore(DialogEvent.ACTIVE);
        this.addChild(this.blocker);
    }
    removeBlocker() {
        this.dispatchCore(DialogEvent.INACTIVE);
        this.removeChild(this.blocker);
    }
    handleDGHOpen() {
        this.addBlocker();
        let token = this.core.getModel().getParameters().getAccessToken();
        let gameServer = this.core.getModel().getParameters().getPrimaryNode();
        let roomName = this.factory.getModel().getRoomName();
        let locale = this.langManager.getLocale().getId();
        if (AppData.DEPLOY_TYPE.isWeb()) {
            this.dghFrame.setAttribute("src", document.location.origin + "/rgs/history/index.html?" + "token=" + token + "&gameServer=" + gameServer + "&roomName=" + roomName + "&locale=" + locale);
        }
        else {
            this.dghFrame.setAttribute("src", "https://alchemy.gamingrealms.net/rgs/history/index.html?" + "token=" + token + "&gameServer=" + gameServer + "&roomName=" + roomName + "&locale=" + locale);
        }
        this.show();
    }
    handleBlockerSelected() {
        this.hide();
    }
    handleResize() {
        let rotated = this.renderer.getRotated();
        if (rotated) {
            // this.hide();
        }
    }
    handleRotate(event) {
        super.handleRotate(event);
        const data = event?.getCurrentTarget() || {};
        this.properties = this.getCurrentProperties(data.forceOrientation);
        if (this.hasPortraitProperties) {
            this.updateFrameStyle();
        }
    }
}
//# sourceMappingURL=DetailedGameHistory.js.map